export default __webpack_public_path__ + "static/media/GregJacobs.cd1bb200.png";